var jq = jQuery.noConflict();

// hCaptcha
var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page
function hCaptchaOnLoad () {
    // Add hcaptcha to all forms on a page
     jq('.h-captcha').each(function () {
        var form = jq(this).closest('form');
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            "sitekey" : window.hCaptchaSiteKey,
            "callback": function (token) {
                jq('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token
                }).appendTo(form);
                form.submit();
            }
        });
    }); 
}

jq(document).ready(function() {
    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr('rel');
        if (!linkRel || (linkRel && linkRel.indexOf('noopener') == -1)) {
            var newRel = linkRel;
            newRel += linkRel && linkRel.length ? ' noopener' : 'noopener';
            jq(this).attr('rel', newRel);
        }
    });
    
    // Scroll more home hero button
    var scrollMore = document.getElementById('scroll-more');
    if (scrollMore) {
        jq(scrollMore).click(function (e) {
            e.preventDefault();
            var target = jq(this).closest('.home-hero, .ir-hero').siblings('.module').first();
            jq('html,body').animate({
                scrollTop: target.offset().top - jq('.general-wrapper > header').height()
            }, 'slow');
        });
    }
    
    jq('.mobile-nav-trigger').click(function(){
        jq('.main-nav').css('height', 'auto');
    });
    
    //Set Cursor pointer to anything with data-toggle
    jq("*[data-toggle]").css( 'cursor', 'pointer' );
    
    jq('header.affixed').affix({
        offset:{
            top: 1
        }
    });
    
    //Circle Stat with Percentage Animation
    var divPercentage = jq('.stats-row-w-percents');
    if(divPercentage.length) {
        jq(document).bind('scroll', function(ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq('.stats-row-w-percents').offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq('.stats-row-w-percents .stat').each(function() {
                    var percDiv = jq(this).find('.number'),
                    svgElm = jq(this).find('.circle'),
                    percentNumber = jq(this).attr('data-percent');
                    svgElm.attr('stroke-dasharray', percentNumber + ', 100');
                    svgElm.addClass('active');
                    jq({percentage: 0}).stop(true).animate({percentage: percentNumber}, {
                        duration : 2000,
                        step: function () {
                        var percentageVal = Math.round(this.percentage);
                        percDiv.text(percentageVal + '%');
                    }
                    }).promise().done(function () {
                        percDiv.text(percentNumber + "%");
                    });
                });
                jq(document).unbind('scroll');
            }
        });
    }
    
    var subNav = jq('.sub-navigation.affixed');
    if(subNav.length) {
        jq(subNav).affix({
            offset: { 
                top: jq(".sub-navigation").offset().top - jq("header").outerHeight()
            }
        });
    }

    var menuRight = document.getElementById( 'mobile-nav' ),
    showRight = document.getElementById( 'showRight' ),
    body = document.body;
    
    if (showRight) {
        showRight.onclick = function() {
            jq(this).toggleClass("active");
            jq('body').toggleClass('push-to-left');
            jq(menuRight).toggleClass("cbp-spmenu-open");
            disableOther( 'showRight' );
            toggleMenuKeybind();
        };
    }
    function disableOther( button ) {
        if( button !== 'showRight' ) {
          jq(showRight).toggleClass("disabled");
        }
    }
    
    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
     function toggleMenuKeybind() {
        var $body = jq('body'),
            $body_events = $body.data("events");
            
        if ($body_events !== null && typeof($body_events.keydown) !== undefined) {
            $body.off('keydown');
        }else {
        $body.on('keydown', function(e) {
            if (e.which == 27) {
                jq('.main-nav').toggleClass("active");
                jq('body').toggleClass('push-to-left');
                jq(menuRight).toggleClass("cbp-spmenu-open");
                disableOther( 'showRight' );
                $body.off('keydown');
            }
        });
        }
    }

    // Basic Form Validation
    var validator = jq(".validate-form");
    validator.each(function () {
      var $form = jq(this);
      var formID = $form.attr('id');
      jq(this).validate({
          rules: {
              password_confirm: {
                  equalTo: "#password",
                  messages: {
                      equalTo: "Passwords must be the same"
                  }
              }
          },
          errorPlacement: function (error, element) {
              error.appendTo(element.parent());
          },
          submitHandler: function (form) {
              if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                  form.submit();
              } else {
                  hcaptcha.reset(window.captchaIDs[formID]);
                  hcaptcha.execute(window.captchaIDs[formID]);
              }
          }
      });
    });
    
    jq('.toggle-button').click(function() {
        jq(this).toggleClass("open");
    });
    
    jq('.fancybox').fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: '600'
    });
    jq('.fancybox-sec-filing').fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: '900'
    });
    
    jq('.fancybox-bio').fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: '0'
    });
    
    jq('.fancybox-modal').fancybox({
        width: 970,
        autoSize: false,
        height: 'auto'
    });
    
    jq(".fancybox\\.iframe").fancybox({
        type: 'iframe',
        iframe : {
            css : {
                width : '80%',
                maxWidth: '1024px',
            }
        }
    });
    
    //Bootrap Select
    jq('.selectpicker').selectpicker({
        iconBase: 'DIN',
        tickIcon: 'no-icon'
    });
    
    //File input
    var fileInput = jq('.file-text input');
    fileInput.change(function(e){
        $this = jq(this);
        var val = $this.val().split('\\');
        var length = val.length;
        var filename = val[length-1];
        jq(this).parent('.file-text').children('.text-wrapper').text(filename);
    });

     // SEC Filing Filters - auto submit form
    jq('#sec-filing-filter select').not('#form_type_custom').on('change', function(e) {
        jq(this).closest('form').submit(); 
    });
    
    jq('#sec-filing-filter .custom-select').change(function(e) {
        var href = jq(this).val();
        if (href) {
            var year = jq('#year').val();
            if (year) {
                href += '?year=' + year;    
            }
            window.location = href;
        }
    });
    
    var $filterSelect = jq('.year-filter .selectpicker');
    if ($filterSelect.length) {
        $filterSelect.on('change', function () {
            var url = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
            var query = "";
            jq('.year-filter .selectpicker').each(function () {
                var prefix = '&';
                if (query.length === 0) {
                    prefix = '?';
                }
                if (jq(this).val() != -1) {
                    query += prefix + jq(this).attr('name') + '=' + jq(this).val();
                }
            });
            url = url + query;
            if (!query) {
            	var full_url = url + '?year=' + jq(this).val();
            	if (window.location.href != full_url) {
            		window.location.href = full_url;
            	}
            } else {
            	if (window.location.href != url) {
            		window.location.href = url;
            	}
            }
       });
    }
});

// Quote Box
function populateQuoteBox(quote) {

    if (jq('.ir-quote-box').length > 0) {
        var quoteContainer = jq('.ir-quote-box[data-symbol="' + quote.symbol + '"]');
    } else {
        var quoteContainer = jq('.quote-box[data-symbol="' + quote.symbol + '"]');
        var home_change = true;
    }
        
    var quote_price = checkQuoteProperty(quote.last),
        quote_change = checkQuoteProperty(quote.change),
        quote_change_pct = checkQuoteProperty(quote.change_pct),
        quote_high = checkQuoteProperty(quote.high),
        quote_low = checkQuoteProperty(quote.low),
        quote_day_low = checkQuoteProperty(quote.day_low),
        quote_day_high = checkQuoteProperty(quote.day_high),
        quote_volume = quote.volume;
        // Quotemedia's volume already comes back formatted, so we do not need to custom format it
        if (quote_volume && quote.use_quotemedia !== true) {
            quote_volume = quote_volume.replace(/\,/g,'');
            quote_volume = parseInt(quote_volume,10);
            quote_volume = abbrNum(quote_volume, 2);
        }   
   

    quoteContainer.find('.time').html('<time />');
    quoteContainer.find('time').attr('datetime', quote.last_trade_time).html(quote.last_trade_time);  
    
    
    if (quote_price == 'N/A') {
        quoteContainer.find('.price .value').html('N/A');
    } else {
          quoteContainer.find('.price .value').html('$' + quote_price);
    }

    if (quote.market_cap == 'N/A') {
        quoteContainer.find('.market-cap .value').html('N/A');
    } else {
        quoteContainer.find('.market-cap .value').html('$' + quote.market_cap);
    }
    
     if (quote.volume == null) {
         quoteContainer.find('.volume .value').html('N/A');
     }else {
         quoteContainer.find('.volume .value').html(quote_volume);
     }

    var change = quote_change.replace(/[+|-]/g, '');

    
    quoteContainer.find('.change .value .number').html(change);
    
    if(quote_change_pct != '0.00' && quote_change_pct != 'N/A' && quote_change_pct != '0' ) {
        quoteContainer.find('.change .value .percent').html('(' + quote_change_pct + '%)');
    }
    if (home_change) {
        quoteContainer.find('.change .home-change-value').html(change);
    }

    if (quote.change.indexOf('+') > -1 && change !== '0' && change !== '0.00') {
        quoteContainer.find('.change').addClass('up');
    } else if (quote.change.indexOf('-') > -1) {
        quoteContainer.find('.change').addClass('down');
    }
    
    if (quote.low == quote.high) {
        week = quote_low;    
    } else {
        var week = quote_low + ' - ' + quote_high;         
    }
    quoteContainer.find('.week-range .value').html(week);

    if (quote.day_low != 'N/A' && quote.day_high != 'N/A') {
        if (quote.day_low == quote.day_high) {
            var day = quote_day_low;
        } else {
            day = quote_day_low + ' - ' + quote_day_high;
        }
        quoteContainer.find('.day-range .value').html(day);
    } else {
        quoteContainer.find('.day-range .value').html(quote.last)
    }
    
    jq('.jsrange').jsRange({
        dayLow: quote_day_low,
        dayHigh: quote_day_high,
        yearLow: quote_low,
        yearHigh: quote_high
    });

}

// SEC Filings expand
jq(".spr-expandable").hide();
jq(".spr-toggle-expandable").click(function() {
	jq(this).next(".spr-expandable").toggle("blind");
});

// Equal Heights
jq(window).on('load', function() {
    checkWidth();
});

function checkQuoteProperty(value) {
    return (value != "N/A") ? parseFloat(value).toFixed(2) : value;
}

function abbrNum(number, decPlaces) {
    var orig = number;
    var dec = decPlaces;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);

    // Enumerate number abbreviations
    var abbrev = ["K", "M", "B", "T"];

    // Go through the array backwards, so we do the largest first
    for (var i = abbrev.length - 1; i >= 0; i--) {

        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);

        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;

            // Handle special case where we round up to the next abbreviation
            if ((number == 1000) && (i < abbrev.length - 1)) {
                number = 1;
                i++;
            }

            // console.log(number);
            // Add the letter for the abbreviation
            number += abbrev[i];

            // We are done... stop
            break;
        }
    }

    //console.log('abbrNum('+ orig + ', ' + dec + ') = ' + number);
    return number;
}

// Add commas to numbers
jq.fn.digits = function() {
    return this.each(function() {
        jq(this).text(jq(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    });
};

//Smooth scroll to
function goToByScroll(id) {
    jq('html,body').animate({
        scrollTop: jq(id).offset().top
    }, 'slow');
}
jq('.smooth').click(function() {
    goToByScroll(jq(this).attr('href'));
    return false;
});

jq(window).ready(function() {
  if (jq(window.location.hash).length) {
    goToByScroll(window.location.hash);          
  }
});

//Check Width
var resizeTimer;
jq(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkWidth, 250);
});

function checkWidth() {
    if (jq(window).width() > 767) {
        jq('.js-same-height, .js-same-height-row').each(function() {
            jq(this).addClass('active');
        });
        sameHeight();
    } else {
        jq('.js-same-height, .js-same-height-row').each(function() {
            jq(this).removeClass('active');
        });
        jq(".js-same-height,.js-same-height-row .js-height").css('min-height', '').css('height', '');
    }
    if (jq(window).width() < 769) {
        jq('.fancybox').each(function() {
            jq(this).addClass('fancybox-holder').removeClass('fancybox');
        });
        jq('.thickbox').each(function() {
            jq(this).addClass('thickbox-holder').removeClass('thickbox');
        });
    } else {
        jq('.fancybox-holder').each(function() {
            jq(this).addClass('fancybox').removeClass('fancybox-holder');
        });
        jq('.thickbox-holder').each(function() {
            jq(this).addClass('thickbox').removeClass('thickbox-holder');
        });
    }

}

//Match Height With Delay for Qmod. Add class same-height to elements
if (isQmod) {    
    var matchHeightInterval;

    matchHeightInterval = setInterval(matchHeightDelay, 50);
    
    function matchHeightDelay()
    {
        if (jq('.qmod-ui-tool').length == 0) return;
        jq('.same-height').matchHeight(); 
        clearInterval(matchHeightInterval);
    }
}


// Same Height
function sameHeight() {
    jq(".js-same-height-row").each(function() {
        var $maxHeight = 0,
            $window_width = jq(window).width();
        jq('.js-same-height', this).css({
            'height': 'auto',
            'min-height': 0
        });
        if ((jq(this).data('cutoff') && jq(this).data('cutoff') >= $window_width) || $window_width < 768) {
            return false;
        }
        jq('.js-same-height', this).each(function() {
            if (jq(this).outerHeight() > $maxHeight) {
                $maxHeight = jq(this).outerHeight();
            }
        }).css('min-height', $maxHeight);
        jq('.js-height', this).css({
            'height': $maxHeight,
            'min-height': 0
        });
    });
}

// Fixes XBRL Filing Close Button click event being unbound by an early call to tb_remove
jq(document).ajaxComplete(function() {
    jq('#TB_closeAjaxWindow #TB_closeWindowButton').on('mousedown', function() {
        tb_remove();
    });
});

// Checkbox Groups
var update_sec_checkboxes = function() {
    if (jq('#ir-sec-all').is(':checked')) {
        jq(".ir-sec-sub").prop('checked', true).prop('disabled', true);
    } else {
        jq(".ir-sec-sub").prop('disabled', false).prop('checked', false);
    }
}
jq('#ir-sec-all').change(update_sec_checkboxes);
if (jq('#ir-sec-all').is(':checked')) {
    jq(".ir-sec-sub").prop('checked', true).prop('disabled', true);
}
